<template>
  <v-app>
    <Appbar />
    <v-main>
      <Information />
      <v-row>
        <v-col
          cols="12"
          class="mb-2  mt-2"
        >
          <v-layout
            d-flex
            justify-center
            align-center
            class="mx-8 pa-0"
          >
            <!--     <div
              :style="`width:5px; height:100%;background-color:${accentColor}`"
              class="mr-4"
            />
            <div style="font-weight: bold;font-size: 18px;">
              プレミアムプランへのアップグレード
            </div>-->
            <v-img
              src="../assets/title.png"
              max-width="500px"
              width="200px"
            />
          </v-layout>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="6"
          lg="6"
          xl="6"
        >
          <v-card
            :tile="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
            class="mx-auto ml-sm-4 fill-width"
            flat
          >
            <v-list>
              <v-list-item three-line>
                <v-list-item-icon>
                  <v-img
                    src="../assets/mark.png"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="color: var(--v-secondary-base);font-weight: bold; font-size:18px;">
                    編集中にプレビュー等のリアルタイム表示！
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    プレビューだけでなく、プロット・テーマ・資料も確認できます。
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item three-line>
                <v-list-item-icon>
                  <v-img
                    src="../assets/mark.png"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="color: var(--v-secondary-base);font-weight: bold; font-size:18px;">
                    アプリ版との同期も！
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    アプリ版との同期でお出かけ中にも執筆が捗ります！
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item three-line>
                <v-list-item-icon>
                  <v-img
                    src="../assets/mark.png"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="color: var(--v-secondary-base);font-weight: bold; font-size:18px;">
                    広告が非表示になります！
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    もちろんアプリ版でも広告は非表示！
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                three-line
              >
                <v-list-item-icon>
                  <v-img
                    src="../assets/mark.png"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="color: var(--v-secondary-base);font-weight: bold; font-size:18px;">
                    画像アップロードも可能な資料作成機能が開放されます！
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                three-line
              >
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-center ">
                    <span
                      style="font-weight: bold; font-size:18px;background: linear-gradient(transparent 50%, yellow 50%); "
                    >
                      ７日間無料でお試しいただけます！
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>


              <v-list-item
                v-if="isiOS"
                three-line
              >
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-center ">
                    <span
                      style="font-weight: bold; font-size:18px;"
                    >ご利用はアプリから！</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="d-flex justify-center">
                    <a
                      href="https://apps.apple.com/jp/app/novewrite/id1524194701"
                      target="_blank"
                    >
                      <img
                        class="mr-4"
                        contain
                        height="40px"
                        src="../assets/appstore.png"
                      >
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.neconotech.novewrite&hl=ja"
                      target="_blank"
                    >
                      <img
                        class="mr-4"
                        contain
                        height="40px"
                        src="../assets/googleplay.png"
                      ></a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="6"
          lg="6"
          xl="6"
        >
          <v-card
            v-if="!isiOS"
            :tile="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
            class="mx-auto mr-sm-4 fill-width"
            flat
          >
            <div class="px-6 py-6">
              <div
                class="mx-auto"
              >
                <h5>プラン</h5>
                <v-row
                  class="pa-4"
                  justify="center"
                >
                  <v-col
                    cols="12"
                    sm="8"
                    md="6"
                    lg="4"
                    xl="3"
                  >
                    <selectable-plan
                      v-model="selectPlan"
                      plan-detail-name="月払い"
                      plan-name="month"
                      plan-gigs="　"
                      plan-dollars="250円 / 月"
                      :is-agreement="isMonthAgreement"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="8"
                    md="6"
                    lg="4"
                    xl="3"
                  >
                    <selectable-plan
                      v-model="selectPlan"
                      plan-detail-name="年払い"
                      plan-name="year"
                      plan-gigs="２ヶ月分お得！"
                      plan-dollars="2,500円 / 年"
                      :is-agreement="isYearAgreement"
                    />
                  </v-col>
                </v-row>
                <h5 class="mt-6 mb-3">
                  クレジットカード情報
                </h5>

                <CardInput
                  @changeCard="onChangeCard"
                />
                <div
                  class="credit-card-inputs"
                  style="display: inline;background-color: #666666;"
                >
                  <h6 class="mt-4 mb-1">
                    プロモーションコード
                  </h6>

                  <v-text-field
                    v-model="promotionCode"
                    style="width: 240px"
                    solo
                  />

                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="accent"
                      class="mt-4 px-8"
                      :disabled="!cardObject || (currentUserPlan && selectPlanId==currentUserPlan.productId && currentUserPlan.isCanceled!=true)"
                      :loading="saving"
                      @click="showConfirm()"
                    >
                      確認
                    </v-btn>
                    <v-spacer />
                  </v-card-actions>
                  <v-card-actions class="mb-0 pb-0">
                    <v-spacer />
                    <p
                      v-if="selectPlan && currentUserPlan && selectPlanId==currentUserPlan.productId && currentUserPlan.isCanceled==true"
                      style="color:red;font-size: 12px;"
                    >
                      このアイテムは既に購入済みです(キャンセル処理済み)
                    </p>
                    <p
                      v-else-if="selectPlan && currentUserPlan && selectPlanId==currentUserPlan.productId"
                      style="color:red;font-size: 12px;"
                    >
                      このアイテムは既に購入済みです
                    </p>
                    <p
                      v-else-if="selectPlan && currentUserPlan"
                      style="color:red;font-size: 12px;"
                    >
                      このプランを購入した場合、既に購入済みのプランから自動で移行されます
                    </p>
                    <v-spacer />
                  </v-card-actions>
                  <v-card-actions class="mt-0 pt-0">
                    <v-spacer />
                    <v-btn
                      v-if="currentUserPlan!=null && selectPlanId==currentUserPlan.productId"
                      :loading="cancelling"
                      outlined
                      color="red"
                      @click="cancel"
                    >
                      このプランを解約する
                    </v-btn>
                  </v-card-actions>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <Footer />
    </v-main>

    <v-dialog
      v-model="confirmDialog"
      max-width="450"
    >
      <v-card class="mx-auto">
        <v-card-title>
          決済確認
        </v-card-title>

        <v-card-subtitle class="mt-3">
          <ul>
            <li>プラン：{{ selectPlan == "month" ? '月払い' : '年払い' }}</li>
            <li>料金：{{ selectPlan == "month" ? '80円 / 月' : '760円 / 年' }}</li>
            <li>カードNo：XXXX-XXXX-XXXX-{{ cardObject ? cardObject.last4 : '' }}</li>
            <li>
              有効期限：{{ cardObject ? `${cardObject.year}/${cardObject.month}` : '' }}
            </li>
            <li v-if="couponResponse">
              プロモーションコード：{{ couponResponse.coupon.name }}(表示価格から{{
                couponResponse.coupon.duration_in_months ?
                  `${couponResponse.coupon.duration_in_months}ヶ月` : `無期限`
              }}{{ couponResponse.coupon.percent_off }}%off)
            </li>
          </ul>
        </v-card-subtitle>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row
              align="center"
              justify="end"
            >
              <v-btn
                text
                @click="onClickConfirm"
              >
                キャンセル
              </v-btn>

              <v-btn
                text
                @click="execute()"
              >
                完了
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import config from "@/const"
import firebase from "firebase";
import SelectablePlan from '@/component/SelectablePlan.vue'
import {mapState} from "vuex";
import foreach from 'lodash.foreach'
import Appbar from '@/component/Appbar.vue'
import Information from '@/component/Information.vue'
import Footer from '@/component/Footer.vue'
import CardInput from '@/component/CardInput.vue'

export default {
  name: "InputCard",
  components: {
    SelectablePlan,
    Appbar,
    Information,
    Footer,
    CardInput
  },
  data() {
    return {
      cancelling: false,
      saving: false,
      cardToken: null,
      users: [],
      userToken: null,
      selectPlan: null,
      accentColor: null,
      backgroundColor: null,
      confirmDialog: false,
      promotionCode: '',
      couponResponse: null,
      response: null,
      cardObject: null,
      isMonthAgreement: false,
      isYearAgreement: false,
      agreementSelectPlan: null,
      isiOS:false
    }
  },
  computed: {
    selectPlanId: function () {
      if (this.selectPlan == "month") {
        return config.PURCHASE_MONTHLY_ID
      } else if (this.selectPlan == "year") {
        return config.PURCHASE_YEARY_ID
      }
      return null
    },
    currentUserPlan: function () {
      const receipt = this.$store.state.userModule.user.purchaseReceipt
      if (receipt == null || receipt.length == 0) {
        return null
      }
      const receiptObj = JSON.parse(receipt)
      if (receiptObj.items.length != 0) {
        var ret = null
        foreach(receiptObj.items, function (item) {
          if (item.osType == 2 && item.expiryTimeMillis > Date.now()) {
            ret = item
          }
        })
        return ret
      }
      return null
    },
  },
  mounted() {
    // this.isiOS= /iP(hone|(o|a)d)/.test(navigator.userAgent)
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
    this.getStripeRequest();
  },
  methods: {
    computed: {
      ...mapState({
        user: state => state.userModule.user,
      })
    },
    showConfirm() {
      this.saving = true;
      const user = firebase.auth().currentUser;
      user.getIdToken(false).then(token => {
        this.userToken = token;
        this.getCoupon();
        this.confirmDialog = true;
        this.saving = false
      }).catch(reason => {
        alert("ユーザー認証でエラーが発生しました。画面をリロードしてお試しください")
        this.saving = false
      })
    },
    onClickConfirm() {
      this.confirmDialog = false;
      this.saving = false;
    },
    /**
     * 決済APIの実行
     * @param planId
     */
    execute() {
      this.confirmDialog = false;
      const planId = this.selectPlan == "month" ? config.PURCHASE_MONTHLY_ID : config.PURCHASE_YEARY_ID;
      axios.post(config.API_URL + "auth/checkout", {
        stripeToken: this.cardObject.id,
        planId: planId,
        coupon: this.promotionCode
      }, {
        headers: {"X-Firebase-Auth": this.userToken},
      }).then(response => {
        this.$store.dispatch("userModule/replaceUser", {ret: response})
        this.saving = false
        this.$router.push("/payments")
      }).catch(reason => {
        if (reason.response.status === 400) {
          const message = reason["response"]["data"]["message"];
          if (message.match("incorrect_cvc")) {
            alert("セキュリティコードが間違っています。")
          } else if (message.match("incorrect_expiry")) {
            alert("有効期限が間違っています。")
          } else if (message.match("processing_error")) {
            alert("処理中にエラーが発生しました。")
          } else if (message.match("incorrect_number")) {
            alert("カード番号が不正です。")
          } else if (message.match("This promotion code cannot be redeemed")) {
            alert("初めての決済でのみ利用可能なプロモーションコードです。")
          } else {
            alert("カード決済に失敗しました。")
          }
        } else {
          alert("しばらく待ってから再度お試しください。")
        }

        this.saving = false
      })
    },
    async getStripeRequest() {
      const user = firebase.auth().currentUser;
      this.userToken = await user.getIdToken(false);
      axios.get(config.API_URL + "auth/checkout", {
        headers: {"X-Firebase-Auth": this.userToken},
      }).then(value => {
        this.response = value.data;
        this.isYearAgreement = this.response.id === config.PURCHASE_YEARY_ID;
        this.isMonthAgreement = this.response.id === config.PURCHASE_MONTHLY_ID;
        this.selectPlan = this.isYearAgreement ? 'year' : 'month';
        this.agreementSelectPlan = this.selectPlan;

      }).catch(err => {
      });
    },
    /**
     * Subscriptionのキャンセル
     * @param id
     */
    cancel(id) {
      const user = firebase.auth().currentUser
      this.cancelling = true
      user.getIdToken(false).then(token => {
        axios.delete(config.API_URL + `auth/subscriptions/${this.currentUserPlan.receipt}`, {headers: {"X-Firebase-Auth": token},}).then((response) => {
          this.$store.dispatch("userModule/replaceUser", {ret: response})
          this.cancelling = false
        }).catch(reason => {
          this.cancelling = false
          alert("解約処理中にエラーが発生しました。再度お試しいただいても改善しない場合はお問い合わせよりご連絡ください。")
        })
      }).catch(reason => {
        this.cancelling = false
        alert("ユーザー認証でエラーが発生しました。画面をリロードしてお試しください")
      })
    },
    getCoupon() {
      if (!this.promotionCode) {
        return
      }
      axios.get(`${config.API_URL}auth/promotion_codes/${this.promotionCode}`, {
        headers: {"X-Firebase-Auth": this.userToken}
      }).then(value => {
        this.couponResponse = value.data;
      })
    },
    onChangeCard(card) {
      this.cardObject = card;
    }
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans&display=swap');

h5 {
  border-left: 5px solid var(--v-secondary-base);
  clear: both;
  padding: 5px 0 5px 15px;
  text-align: left;
  color: #000000;
  font-size: 16px;
}
</style>
